import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { CONTACT, NAV_LINKS, SERVICES, SOCIALS, whatsappLink } from "../data/content";

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-gold/10 bg-navy-950">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <a href="#home" data-testid="footer-logo" className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white/95 p-1 ring-1 ring-gold/40">
              <img src="/assets/faithh-logo.png" alt="Faithh Business Consultancy logo" className="h-8 w-8 object-contain" />
            </span>
            <span className="leading-none">
              <span className="block font-display text-lg font-bold tracking-wide text-slate-50">FAITHH</span>
              <span className="block font-mono text-[9px] uppercase tracking-[0.32em] text-gold-soft/90">Business Consultancy</span>
            </span>
          </a>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            From compliance to growth — UAE business consultancy and digital solutions, delivered with care.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {SOCIALS.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${social.label.toLowerCase()}`}
                  aria-label={`Faithh on ${social.label}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-gold/25 bg-gold/8 text-gold transition-all duration-400 hover:-translate-y-0.5 hover:border-gold/60 hover:bg-gold/15"
                >
                  <Icon className="h-5 w-5" />
                </a>
              );
            })}
          </div>
        </div>

        <nav aria-label="Footer">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold-soft/80">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-slate-400 transition-colors duration-300 hover:text-gold-soft">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold-soft/80">Services</p>
          <ul className="mt-5 space-y-3">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.id}>
                <a href="#services" data-testid={`footer-service-${s.id}`} className="text-sm text-slate-400 transition-colors duration-300 hover:text-gold-soft">
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold-soft/80">Get In Touch</p>
          <ul className="mt-5 space-y-3.5 text-sm text-slate-400">
            <li>
              <a href={whatsappLink("Hello Faithh!")} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold-soft">
                <MessageCircle className="h-4 w-4 shrink-0 text-gold/70" />
                {CONTACT.whatsappDisplay}
              </a>
            </li>
            <li>
              <a href={`tel:${CONTACT.phone}`} data-testid="footer-phone" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold-soft">
                <Phone className="h-4 w-4 shrink-0 text-gold/70" />
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 break-all transition-colors duration-300 hover:text-gold-soft">
                <Mail className="h-4 w-4 shrink-0 text-gold/70" />
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 shrink-0 text-gold/70" />
              {CONTACT.location}
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} Faithh Business Consultancy. All rights reserved.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.26em] text-gold/50">Compliance · Digital · Growth</p>
      </div>
    </div>
  </footer>
);
